var _ = require('underscore');
var ko = require('knockout');
var i18n = require('./i18n.js');

// A view model class to manage the different types of notifications being
// displayed on the page.
var ViewModel = function() {
  // The flashes currently being shown.
  this.flashes = ko.observableArray();

  // How long to show each flash message, in milliseconds.
  this._flash_timeout = 5000;
};

// Public: Display a flash message on the page. Flash messages are displayed at
// the top of the viewport for a short time period. After that, they're
// automatically hidden.
//
// keyOrString   - String translation key or actual string to display.
// substitutions - Object of data to use for substitutions (default: none).
// options       - Object of options for displaying the notification:
//                 "limit" - The maximum number of identical messages to display
//                           at once (default: unlimited).
//
// Returns nothing.
ViewModel.prototype.flash = function(keyOrString, substitutions, options) {
  options = options || {};

  // Get the string.
  var str = i18n.t(keyOrString, substitutions);

  // Limit the number of identical messages.
  if (_.isNumber(options['limit']) &&
      _.select(this.flashes(), function(f) { return f['message'] == str; }).length >= options['limit'])
    return;

  // Add the flash message and remove it after the timeout.
  this.flashes.push({ message: str });
  setTimeout(function() {
    this.flashes.shift();
  }.bind(this), this._flash_timeout);
};

var notifications = new ViewModel();
module.exports = {
  instance: notifications,
  flash: notifications.flash.bind(notifications),
  ViewModel: ViewModel
};
